import Cookies from "js-cookie";
import { createActionType, createAsyncAction } from "./create-actions";
export const USER_GET_ALL = createActionType("USER_GET_ALL");
export const USER_GET_By_ID = createActionType("USER_GET_By_ID");
export const USER_EDIT = createActionType("USER_EDIT");
export const USER_REMOVE = createActionType("USER_REMOVE");
export const GET_CURRENT_USER_INFO = createActionType("GET_CURRENT_USER_INFO");

export const userGetAll = () =>
  createAsyncAction(USER_GET_ALL, "/user/get_users", "get", undefined, {
    Authorization: `Bearer ${Cookies.get("token")}`,
  });

export const getCurrentUserInfo = () =>
  createAsyncAction(
    GET_CURRENT_USER_INFO,
    "/user/get_current_user_info",
    "get",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const userGetById = (id: any) =>
  createAsyncAction(
    USER_GET_By_ID,
    `/user/get_user_by_id/${id}`,
    "get",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const userEdit = (id: any, data: any) =>
  createAsyncAction(USER_EDIT, `/user/edit_user_by_id/${id}`, "put", data, {
    Authorization: `Bearer ${Cookies.get("token")}`,
  });

export const userRemove = (id: any) =>
  createAsyncAction(
    USER_REMOVE,
    `/user/remove_user_by_id/${id}`,
    "delete",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );
